import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

import { SayfalamaSonuc } from '@models/genel/SayfalamaSonuc';
import { YolcuListesiInfo } from '@core/models/ebilet/YolcuListesiInfo';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
// import { HavayoluEbiletInfo } from '@core/models/ebilet/HavayoluEbiletInfo';



@Injectable()
export class YolcuListesiService {
    private srvUrl: string;
    public callFunction:Function;
    constructor(private http: HttpClient) {
        this.srvUrl = environment.BASE_URL + 'yolculistesi/';
    }

    getData(parametersModel?: any): Observable<SayfalamaSonuc> {
         return this.http.get<SayfalamaSonuc>(this.srvUrl,{ params: parametersModel });

    }

    ekleGuncelle(YolcuListesiInfo: YolcuListesiInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(this.srvUrl + 'ekle/',  YolcuListesiInfo );
    }

    getBelgeTipleri(): Observable<IslemSonuc> {
        // return this.http.post<IslemSonuc>(this.srvUrl + 'belge/',null );
        return null;
    }

    getHizmetNevileri(): Observable<IslemSonuc> {

		return this.http.get<IslemSonuc>(this.srvUrl + 'hizmet/'  );
    }

    get(id:number): Observable<YolcuListesiInfo> {
        return this.http.get<YolcuListesiInfo>(this.srvUrl +  id.toString());
    }

    select_by(id:number): Observable<YolcuListesiInfo> {
        return this.http.get<YolcuListesiInfo>(this.srvUrl + 'select_by/'+  id.toString());
    }

    sil(id:number): Observable<YolcuListesiInfo> {
        return this.http.delete<YolcuListesiInfo>(this.srvUrl +  id.toString());
    }

}
